import { useEffect, useState, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import { ModalProvider } from "./context/ModalContext";

const Features = lazy(() => import("./components/Features"));
const About = lazy(() => import("./components/About"));
const Newsletter = lazy(() => import("./components/Newsletter"));
const Pricing = lazy(() => import("./components/Pricing"));
const LogoList = lazy(() => import("./components/LogoList"));
const Clients = lazy(() => import("./components/Clients"));
const DistributorFinder = lazy(() => import("./components/DistributorFinder"));
const Admin = lazy(() => import("./products/Admin"));
const POS = lazy(() => import("./products/POS"));
const Accounting = lazy(() => import("./products/Accounting"));
const PayRoll = lazy(() => import("./products/PayRoll"));
const Food = lazy(() => import("./products/Food"));
const Others = lazy(() => import("./products/Others"));
const Footer = lazy(() => import("./shared/Footer"));
const RealStateSection = lazy(() => import("./shared/RealStateSection"));

function App() {
  const { hash } = useLocation();
  const [loadDeferredSections, setLoadDeferredSections] = useState(false);

  useEffect(() => {
    if (hash) {
      setLoadDeferredSections(true);
      return;
    }

    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(() => {
        setLoadDeferredSections(true);
      });

      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = window.setTimeout(() => {
      setLoadDeferredSections(true);
    }, 1);

    return () => window.clearTimeout(timeoutId);
  }, [hash]);

  useEffect(() => {
    if (!hash) return;

    const id = hash.replace("#", "");

    const scrollToHashElement = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    };

    scrollToHashElement();

    const timeoutId = window.setTimeout(scrollToHashElement, 300);

    return () => window.clearTimeout(timeoutId);
  }, [hash, loadDeferredSections]);

  return (
    <ModalProvider>
      <>
        <Navbar />
        <main id="main-content">
          <Home />

          {loadDeferredSections && (
            <Suspense fallback={null}>
              <Features />
              <RealStateSection />
              <LogoList />
              <Clients />
              <About />
              <Admin />
              <POS />
              <Accounting />
              <PayRoll />
              <Food />
              <Others />
              <Pricing />
              <DistributorFinder />
              <Newsletter />
              <Footer />
            </Suspense>
          )}
        </main>
      </>
    </ModalProvider>
  );
}

export default App;